/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournaments_Col_StateInputs */



/**
* | output |
* | --- |
* | "State" |
*
* @param {Tournaments_Col_StateInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournaments_col_state = /** @type {((inputs?: Tournaments_Col_StateInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournaments_Col_StateInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("État")
	if (locale === "es") return /** @type {LocalizedString} */ ("Estado")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Estado")
	if (locale === "it") return /** @type {LocalizedString} */ ("Stato")
	return /** @type {LocalizedString} */ ("State")
});